const getOrderLineNarrative = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    return indexOrderLine ? indexOrderLine.Narrative : null;
  }
  return orderLine
    ? orderLine.map(item => item.Narrative).join(', ')
    : null;
};

export default getOrderLineNarrative;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineNarrative.js